import { render, staticRenderFns } from "./InsulationWidth.vue?vue&type=template&id=8cfa6dca&"
import script from "./InsulationWidth.vue?vue&type=script&lang=js&"
export * from "./InsulationWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports